import { render, staticRenderFns } from "./LibraryGoalCard.vue?vue&type=template&id=15aca348&scoped=true"
import script from "./LibraryGoalCard.vue?vue&type=script&lang=js"
export * from "./LibraryGoalCard.vue?vue&type=script&lang=js"
import style0 from "./LibraryGoalCard.vue?vue&type=style&index=0&id=15aca348&prod&scoped=true&lang=less"
import style1 from "./LibraryGoalCard.vue?vue&type=style&index=1&id=15aca348&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aca348",
  null
  
)

export default component.exports